/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountPasswordReset
 */
export interface AccountPasswordReset {
    /**
     * 
     * @type {string}
     * @memberof AccountPasswordReset
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof AccountPasswordReset
     */
    password: string;
}

export function AccountPasswordResetFromJSON(json: any): AccountPasswordReset {
    return {
        'token': json['token'],
        'password': json['password'],
    };
}

export function AccountPasswordResetToJSON(value?: AccountPasswordReset): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'token': value.token,
        'password': value.password,
    };
}


